/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
:host .cb_box {
  height: calc(24rem/14);
  width: calc(24rem/14);
  border: 1px solid var(--davinci-color-outline,#B4BEC5);
  background-color: white;
}
:host .cb_box svg {
  display: none;
  width: calc(22rem/14);
  height: calc(22rem/14);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host .cb_box, :host .cb_label {
  display: inline-block;
  vertical-align: middle;
}
:host .cb_label {
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  line-height: calc(24rem/14);
  padding-left: calc(8rem/14);
}
:host .cb_label ::slotted(*) {
  line-height: calc(24rem/14);
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
}
:host .cb_label.empty {
  display: none;
}

:host([checked]) .cb_box svg {
  display: block;
}

:host([disabled]) {
  pointer-events: none;
}
:host([disabled]) .cb_label {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}
:host([disabled]) .cb_label ::slotted(*) {
  color: #8999A4;
  color: var(--davinci-color-text-disabled, #8999A4);
}
:host([disabled]) .cb_box {
  border-color: #D2D9DD;
  border-color: var(--davinci-color-outline-disabled, #D2D9DD);
}
:host([disabled]) .cb_box svg {
  fill: #D2D9DD;
  fill: var(--davinci-color-outline-disabled, #D2D9DD);
}

:host(:empty) .cb_label {
  display: none;
}`;
export { style };
//# sourceMappingURL=Checkbox.style.js.map